// extracted by mini-css-extract-plugin
module.exports = {"root":"_2NrG4","bg":"VFgHr","arrow":"_1NMWF"};